import React from "react";

export type FullScreenState = {
  fullScreen: boolean;
  toggleFullScreen: () => void;
}

export const FullScreenContext = React.createContext<FullScreenState>({
  fullScreen: false,
  toggleFullScreen: () => {
  }
});